import { useCallback, useEffect } from 'react';
import { fetchMe } from '../api/auth';
import { PlatformAuthBootstrap } from '@jarvis/platform-ui';
import { useSiteCapabilitiesStore } from '../site/useSiteCapabilitiesStore';
import { SupportWidgetBodyFlag } from '../supportWidget/SupportWidgetBodyFlag';
import { AssistantAuthBodyFlag } from './AssistantAuthBodyFlag';
import { useAuthStore } from './useAuthStore';

type Me = Awaited<ReturnType<typeof fetchMe>>;

/** Loads `/api/auth/me` once — Entra cookie session via AssistantApi BFF. */
export function AuthBootstrap() {
  const loadCapabilities = useSiteCapabilitiesStore((s) => s.load);
  useEffect(() => {
    void loadCapabilities();
  }, [loadCapabilities]);

  const isAuthenticated = useCallback((me: Me) => me.authenticated, []);
  const mapAuthenticated = useCallback(
    (me: Me) => ({
      username: me.username,
      displayName: me.displayName,
      roles: me.roles ?? []
    }),
    []
  );

  return (
    <>
      <AssistantAuthBodyFlag />
      <SupportWidgetBodyFlag />
      <PlatformAuthBootstrap
        fetchMe={fetchMe}
        isAuthenticated={isAuthenticated}
        mapAuthenticated={mapAuthenticated}
        useAuthStore={useAuthStore}
      />
    </>
  );
}
